import type { SwAuthTelemetryEvent } from './swAuthTelemetry.ts'

const MAX_EVENTS = 80

export type SwAuthDebugBufferedEvent = {
  at: number
  atLabel: string
  event: SwAuthTelemetryEvent
}

const events: SwAuthDebugBufferedEvent[] = []

function formatTime(ms: number): string {
  try {
    return new Date(ms).toLocaleTimeString()
  } catch {
    return String(ms)
  }
}

export function pushSwAuthDebugEvent(event: SwAuthTelemetryEvent): void {
  const at = Date.now()
  events.push({ at, atLabel: formatTime(at), event })
  if (events.length > MAX_EVENTS) {
    events.splice(0, events.length - MAX_EVENTS)
  }
}

export function getSwAuthDebugEvents(): readonly SwAuthDebugBufferedEvent[] {
  return events
}

export function clearSwAuthDebugEvents(): void {
  events.length = 0
}

export function formatSwAuthTelemetryEvent(event: SwAuthTelemetryEvent): string {
  switch (event.kind) {
    case 'sync_posted':
      return `sync_posted matched=${event.matched} waitMs=${event.waitMs} hasEpoch=${event.hasEpoch}${event.preflightReadFailed ? ' preflightReadFailed' : ''}`
    case 'reload_ok':
      return `reload_ok attempt=${event.attempt}`
    case 'reload_mismatch_retry':
      return `reload_mismatch_retry attempt=${event.attempt} kind=${event.mismatchKind}`
    case 'reload_mismatch_exhausted':
      return `reload_mismatch_exhausted kind=${event.mismatchKind}`
    case 'reload_without_epoch':
      return 'reload_without_epoch'
    case 'idb_read_failed':
      return `idb_read_failed: ${event.message}`
    default:
      return String((event as { kind?: string }).kind ?? 'unknown')
  }
}
